/** Available multi-tenancy modes */
export enum MultiTenancyModeEnum {
  /** Multi-tenancy enabled: everyone can create new tenants and edit their own tenants */
  ENABLED = 'ENABLED',
  /** Multi-tenancy limited: everyone can work in their own tenants, but only super-admins can create or edit tenants */
  LIMITED = 'LIMITED',
  /** Multi-tenancy disabled */
  DISABLED = 'DISABLED',
}
